var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',[_c('h4',[_vm._v(_vm._s(_vm.$t('home.title')))]),_c('br')]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shadow-sm p-3 mb-2 mt-2 bg-body rounded"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('h5',[_vm._v("Belege")])])]),_c('div',{staticClass:"row"},[_c('br'),_c('div',{staticClass:"col-md-3"})])])
}]

export { render, staticRenderFns }